module.exports = __webpack_public_path__ + "static/media/Corona-Hinweis-Gr.0b2edafb.jpg";